module.exports = __webpack_public_path__ + "img/mute.1d4a242f.svg";